import styles from "./VideoEmbed.module.scss";

interface VideoEmbedProps {
  url: string;
  width?: any;
  height?: any;
}

export const getEmbedUrl = (url: string) => {
  // YouTube or Vimeo
  const isYouTube = url?.includes('youtube.com') || url?.includes('youtu.be');
  const isVimeo = url?.includes('vimeo.com');

  if (isYouTube) {
    const youtubeMatch = url?.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/]+\/[^\/]+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    if (youtubeMatch) {
      return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
    }
  } else if (isVimeo) {
    const vimeoMatch = url?.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) {
      return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    }
  }
  // Add support for other video platforms here

  return null;
};

export function VideoEmbed(data : any) {
  const { url, width, height } =  data;

  if (typeof url !== 'string') {
    return null
  }

  const embedUrl = getEmbedUrl(url);

  if (!embedUrl) return <div>Invalid video URL</div>;

  return (
    <div className={styles.videoEmbedContainer}>
      <iframe
          width={width || "560"}
          height={height || "315"}
          src={embedUrl || ""}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className={styles.videoEmbed}
      />
    </div>
  );
}
